<template>
  <div>
    <Navbar v-if="$route.meta.navbar"/>
    <Breadcrumb v-if="$route.meta.navbar" />
    <div class="col-12 ps-3">
      <div class="mb-3">
        <label class="form-label">Login screen text</label>
        <vue-editor 
          v-model="login_text" 
          :editorToolbar="editortoolbar"
          @text-change="savepref(login_text)"
        ></vue-editor>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "./Navbar.vue";
import Breadcrumb from "./Breadcrumb";
import VueEditor from "./CustomControls/VueEditor.vue";

var editortools = [
  [{ font: [] }],
  [{ header: [false, 1, 2, 3, 4, 5, 6] }],
  [{ size: ["small", false, "large", "huge"] }],
  ["bold", "italic", "underline", "strike"],
  [
    { align: "" },
    { align: "center" },
    { align: "right" },
    { align: "justify" }
  ],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ color: [] }, { background: [] }],
  ['link'],
];

export default {
  components: {
    Navbar,
    Breadcrumb,
    VueEditor,
  },
  name: 'DefaultMailTexts',
  data() {
    return {
      editortoolbar: editortools,
      login_text: ''
    }
  },
  created() {
    this.getpref();
  },
  methods: {
    savepref(value) {
      this.$store.dispatch('syspref_save', { key: 'login_text',value: value });
    },
    getpref() {
      this.$store.dispatch('syspref_fetch', { key: 'login_text' })
      .then((resp) => {
        this.login_text = resp.data.value;
      });
    },
  },  
}
</script>
<style></style>
